import React from "react";

import GamesNav from "../Mach-nav/GamesNav";
import GameTable from "../GameTable/GameTable";

const RightBar = () => {
  return (
    <>
      <div className="games !mt-1">
        <GamesNav />
      </div>
      <div>
        <GameTable />
      </div>
    </>
  );
};

export default RightBar;
